import { render } from "./TheFooter.vue?vue&type=template&id=6b562334&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=6b562334&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\hes-chauffeurs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b562334"]])

export default __exports__